import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import { ACTION_TYPE } from 'components/DefinableTable';

export const ACTIONS = {
  ROW_SELECT_MULTIPLE: 'action.row-select-multiple',
  ROW_SELECT: 'action.row-select',
};

export const targetsTableDef = {
  detailPanel: {
    gridCols: 3,
    collapsible: true,
    expandTooltipIntlKey: 'notifications.targets.expandDetailPane.tooltip',
    collapseTooltipIntlKey: 'notifications.targets.collapseDetailPane.tooltip',
    expandIcon: ChevronLeft,
    collapseIcon: ChevronRight,
  },
  actionColIntlKey: false,
  selectAllTooltipIntlKey: 'notifications.targets.select-all.tooltip',
  selectNoneTooltipIntlKey: 'notifications.targets.select-none.tooltip',
  defaultSort: [{ source: 'surname', direction: 'asc' }],
  columns: [
    {
      headerIntlKey: 'notifications.targets.field.forename',
      rowCellSource: 'forename',
    },
    {
      headerIntlKey: 'notifications.targets.field.surname',
      rowCellSource: 'surname',
    },
    {
      headerIntlKey: 'notifications.targets.field.receivers',
      rowCellSource: 'receiverType.label',
    },
    {
      headerIntlKey: 'notifications.targets.field.phone',
      rowCellSource: 'mobilePhone',
    },
    {
      headerIntlKey: 'notifications.targets.field.email',
      rowCellSource: 'email',
    },
  ],
  rows: {
    source: '',
    highlightSelected: true,
    rowAction: 0,
    noDataIntlKey: 'notifications.targets.heading.no-data',
    multiSelectAction: {
      type: ACTION_TYPE.ROW_SELECT,
      action: ACTIONS.ROW_SELECT_MULTIPLE,
    },
    actions: [
      {
        type: ACTION_TYPE.ROW_SELECT,
        action: ACTIONS.ROW_SELECT,
      },
    ],
  },
};
